import { Component, Input, OnChanges } from '@angular/core';

import { Opportunity } from '@main-client/src/app/opportunity/opportunity.model';

import get from 'lodash-es/get';
import head from 'lodash-es/head';

enum READABLE_MEETING_METHODS {
  'cisco-webex' = 'Cisco Webex',
  'go-to-webinar' = 'GoToWebinar',
  'google-hangout' = 'Google Meet',
  'in-person' = 'In Person',
  'microsoft-teams' = 'Microsoft Teams',
  other = 'Other',
  phone = 'Phone',
  slack = 'Slack',
  skype = 'Skype',
  zoom = 'Zoom',
}

interface Event extends Opportunity {
  location?: string;
}

@Component({
  selector: 'app-feed-item-event-meeting-method',
  templateUrl: './feed-item-event-meeting-method.component.html',
})
export class FeedItemEventMeetingMethodComponent implements OnChanges {
  @Input() opportunity: Event;
  @Input() eventLocation: string;
  READABLE_MEETING_METHODS = READABLE_MEETING_METHODS;
  location: string;
  showSecondaryLocation: boolean;
  locationMapUrl: string;

  ngOnChanges() {
    this.location =
      this.eventLocation ||
      head(get(this.opportunity, 'location', '').split(','));
    this.locationMapUrl = [
      'https://www.google.com/maps/search/?api=1&query=',
      encodeURI(this.location),
    ].join('');
    this.showSecondaryLocation =
      this.location !==
      get(this.opportunity, 'event_location.custom_label', '');
  }
}
